export default __webpack_public_path__ + "static/media/homeFraude.88741ba6.svg";